import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import HotelRoomsAPI from '../../api/hotelRooms';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getRooms(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getRoomById: _state => id => {
    return _state.records.find(record => record.id === Number(id)) || {};
  },
};

export const actions = {
  get: async function getRooms({ commit }) {
    commit(types.SET_HOTEL_ROOMS_UI_FLAG, { isFetching: true });
    try {
      const response = await HotelRoomsAPI.get();
      commit(types.SET_HOTEL_ROOMS, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_HOTEL_ROOMS_UI_FLAG, { isFetching: false });
    }
  },

  create: async function createRoom({ commit }, roomObj) {
    commit(types.SET_HOTEL_ROOMS_UI_FLAG, { isCreating: true });
    try {
      const response = await HotelRoomsAPI.create(roomObj);
      commit(types.ADD_HOTEL_ROOM, response.data);
      return response.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_HOTEL_ROOMS_UI_FLAG, { isCreating: false });
    }
  },

  update: async function updateRoom({ commit }, { id, ...updateObj }) {
    commit(types.SET_HOTEL_ROOMS_UI_FLAG, { isUpdating: true });
    try {
      const response = await HotelRoomsAPI.update(id, updateObj);
      commit(types.EDIT_HOTEL_ROOM, response.data);
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_HOTEL_ROOMS_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async function deleteRoom({ commit }, id) {
    commit(types.SET_HOTEL_ROOMS_UI_FLAG, { isDeleting: true });
    try {
      await HotelRoomsAPI.delete(id);
      commit(types.DELETE_HOTEL_ROOM, id);
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_HOTEL_ROOMS_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_HOTEL_ROOMS_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_HOTEL_ROOMS]: MutationHelpers.set,
  [types.ADD_HOTEL_ROOM]: MutationHelpers.create,
  [types.EDIT_HOTEL_ROOM]: MutationHelpers.update,
  [types.DELETE_HOTEL_ROOM]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
